import React, {useEffect} from 'react';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import TableCell from '@material-ui/core/TableCell';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import SDKTable from './../sdk/sdkTable/sdkTable';
import SessionResource from './../resources/sessionResource';
import CircularProgress from '@material-ui/core/CircularProgress';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import SessionRow from './sessionRow';

import {data} from './config';

const {sessionHeaders} =  data;


const sessionResource = new SessionResource();
const BasicStudentRow = (props)=>{
	const { row } = props;
	const [open, setOpen] = React.useState(false);
	const [loadingContent, setLoadingContent] = React.useState(false);   

	const onCollage = async()=>{
    	setOpen(!open);
    }
	const getSubTable = ()=>{
    	if(!open) return <React.Fragment/>;
    	let initialFilter = {"students._id": (row._id || row.id)}
    	return (
    		<SDKTable 
		    	rowId={"_id"}
    			metaData={{studentId:(row._id||row.id)}}
		    	tableHeaders={sessionHeaders} 
		    	refreshChannel={"refreshSessionTable"}
		    	defaultOrder={{name:'date', value:'desc'}}
		    	resource={sessionResource}
		    	initialFilter= {initialFilter}
		    	hasSearch="1"
		    	minHeight={100}
		    	inlineAction={1}
		    	onRowAction={props.onAction}
		    >
		    	<SessionRow/>
		    </SDKTable>
    	)
    }

    return (
    	<React.Fragment>
    		<TableRow className="user-row">
		        <TableCell>
					<IconButton aria-label="expand row" size="small" onClick={() =>onCollage()}>
			            	{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
			        </IconButton>
			        <IconButton className="table-action" aria-label="expand row" size="small" onClick={()=>props.onAction('onEditStudentForm', row)}>
						<EditIcon/>
					</IconButton>
		        </TableCell>
		         <TableCell scope="row">{row.studentName}</TableCell>
		        <TableCell scope="row">{row.course}</TableCell>
		        <TableCell scope="row">{row.level}</TableCell>
		        <TableCell scope="row">{row.sessionDateTime}</TableCell>
		        <TableCell scope="row">{row.instructorName}</TableCell>
		    </TableRow>
		    <React.Fragment>
		    	<TableRow className="sub-table">
				        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
				          <Collapse in={open} timeout="auto" unmountOnExit>
				            <Box margin={1}>
				              <div className="row-flex">
									<Typography variant="h6" gutterBottom component="div">
						                Student Sessions
						            </Typography>
							  </div>
				              <React.Fragment>
				              	{loadingContent?<div className="row-flex center-flex"><CircularProgress/></div>:<React.Fragment/>}
				              </React.Fragment>	

				              <React.Fragment>
				              	{getSubTable()}
				              </React.Fragment>
				            </Box>
				          </Collapse>
				        </TableCell>
				    </TableRow>
				
		    </React.Fragment>
		</React.Fragment>
    );
}

export default BasicStudentRow;
